import { $, $$, on, doc } from './util.js';

/* 6. CODE COPY BUTTONS (FRD 6.9) */
export function initCodeCopy() {
	$$('.article-body pre').forEach(function (pre) {
		if ($('.code-copy', pre)) { return; }
		// An API example puts its own button beside each panel (api-example.js).
		if (pre.closest('[data-api-example]')) { return; }
		var btn = doc.createElement('button');
		btn.type = 'button';
		btn.className = 'code-copy';
		btn.textContent = 'Copy';
		on(btn, 'click', function () {
			var code = $('code', pre) || pre;
			var text = code.textContent;
			var done = function () {
				btn.textContent = 'Copied';
				setTimeout(function () { btn.textContent = 'Copy'; }, 1600);
			};
			if (navigator.clipboard && navigator.clipboard.writeText) {
				navigator.clipboard.writeText(text).then(done, function () { btn.textContent = 'Press ⌘C'; });
			} else {
				var ta = doc.createElement('textarea');
				ta.value = text; doc.body.appendChild(ta); ta.select();
				try { doc.execCommand('copy'); done(); } catch (e) { btn.textContent = 'Press ⌘C'; }
				doc.body.removeChild(ta);
			}
		});
		pre.appendChild(btn);
	});
}
